import script from "./link-template.vue?vue&type=script&lang=ts&setup=true"
export * from "./link-template.vue?vue&type=script&lang=ts&setup=true"

import "./link-template.vue?vue&type=style&index=0&id=8ec0cc20&lang=scss"

const __exports__ = script;

export default __exports__